"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);

  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).apply(this, arguments));
  }

  (0, _createClass2["default"])(_default, [{
    key: "setState",

    /**
     * override
     * ensure that setState called on mounted component
     * @param {object} state
     * @param {function} [cb]
     * @return {Promise}
     */
    value: function setState(state, cb) {
      var _this = this;

      if (!this.isUnmounted) {
        if (typeof cb === 'function') {
          return (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "setState", this).call(this, state, cb);
        } else {
          return new Promise(function (resolve) {
            (0, _get2["default"])((0, _getPrototypeOf2["default"])(_default.prototype), "setState", _this).call(_this, state, resolve);
          });
        }
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // flag for unmounted components
      this.isUnmounted = true;
    }
  }, {
    key: "render",
    value: function render() {
      if (typeof this.template === 'function') {
        return this.template.call(this);
      } else {
        return _react["default"].createElement("span", null);
      }
    }
  }, {
    key: "compileStyled",
    value: function compileStyled(styleSheet) {
      if (typeof styleSheet === 'function') {
        return styleSheet.call(this, _objectSpread({}, this.props.theme || {}), this.props, this.state || {});
      } else {
        return {};
      }
    }
  }, {
    key: "_processCollection",
    value: function _processCollection(collection) {
      var result = collection;

      if (typeof this.props.processor === 'function') {
        result = this.props.processor(collection.models || collection);
      }

      return result;
    }
  }]);
  return _default;
}(_react["default"].Component);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "propTypes", {
  processor: _propTypes["default"].func,
  theme: _propTypes["default"].object
});
(0, _defineProperty2["default"])(_default, "displayName", 'Component');